import { useEffect, useState } from "react"
import { useAuth } from "../../../../../modules/auth"
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi"
import { FieldFilterType } from "../../../../base/types"

interface IPersonIdBatch {
    personid?: string,
    batch?: string,
}

interface IPersonGroupId {
    personGroupId?: string,
}

export const useGetPersonId = () => {
    const { user, siteId } = useAuth()
    const [getRecords] = useLazyReadMultipleQuery()
    const [records, setRecords] = useState<IPersonIdBatch[]>([])
    const [batchId, setBatchId] = useState<string | null>(null)

    useEffect(() => {
        if (!user?.contactId) return;

        getHistory()
        // eslint-disable-next-line
    }, [user])

    const getHistory = (): Promise<IPersonIdBatch[]> => {
        if (!user?.contactId) {
            return Promise.reject('User contact not found.')
        }

        return getRecords({
            userId: user?.contactId || '',
            portalId: siteId || '',
            tableId: "contact",
            fieldList: ["edtec365_personid", "slcm_batch"],
            filters: [{
                group: 0, filters: [
                    { field: "contactid", type: FieldFilterType.Const, value: user.contactId }]
            }]
        })
            .unwrap()
            .then((data) => {
                const records = data.records.map<IPersonIdBatch>(p => ({
                    personid: p["edtec365_personid"],
                    batch: p["slcm_batch"],
                }))

                setRecords(records)
                if (records.length > 0) {
                    setBatchId(records[0].batch || null)
                }
                return Promise.resolve(records);
            })
    }

    const { data: personGroupData } = useGetPersonGroupId(batchId)

    return { data: records, personGroupData }
}

export const useGetPersonGroupId = (batchId: string | null) => {
    const { user, siteId } = useAuth()
    const [getRecords] = useLazyReadMultipleQuery()
    const [records, setRecords] = useState<IPersonGroupId[]>([])

    useEffect(() => {
        if (!batchId || !user?.contactId) return;

        getHistory()
        // eslint-disable-next-line
    }, [batchId])

    const getHistory = (): Promise<IPersonGroupId[]> => {
        if (!batchId || !user?.contactId) {
            return Promise.reject('Batch ID or user contact not found.')
        }

        return getRecords({
            userId: user?.contactId || '',
            portalId: siteId || '',
            tableId: "slcm_batch",
            fieldList: ["edtec365_persongroupid"], // Fetch personGroupId field
            filters: [{
                group: 0, filters: [
                    { field: "slcm_batchid", type: FieldFilterType.Const, value: batchId }]
            }]
        })
            .unwrap()
            .then((data) => {
                const records = data.records.map<IPersonGroupId>(p => ({
                    personGroupId: p["edtec365_persongroupid"] // Extract personGroupId
                }))

                setRecords(records)
                return Promise.resolve(records);
            })
    }
    return { data: records }
}
